var _style, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMomoPay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#AB006B;}\r\n\t.st1{fill:#F8F8F8;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.2,0H9.8C4.4,0,0,4.4,0,9.8v80.3c0,5.4,4.4,9.8,9.8,9.8h80.3c5.4,0,9.8-4.4,9.8-9.8V9.8 C100,4.4,95.6,0,90.2,0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2_9_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71.1,47.5c8.9,0,16.1-7.3,16.1-16.2S80,15.2,71.1,15.2c-8.9,0-16.1,7.3-16.1,16.2 C54.9,40.3,62.2,47.5,71.1,47.5C71.1,47.5,71.1,47.5,71.1,47.5z M71.1,24.3c3.9,0,7,3.2,7,7.1s-3.2,7-7.1,7c-3.9,0-7-3.2-7-7 C64.1,27.5,67.2,24.3,71.1,24.3C71.1,24.3,71.1,24.3,71.1,24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.6,15.2c-2.6,0-5.2,0.8-7.3,2.3c-2.2-1.5-4.7-2.3-7.3-2.3c-6.5-0.2-12,4.9-12.3,11.4v20.9h9.8V26.6 c0.1-1.3,1.1-2.3,2.4-2.2c1.3-0.1,2.4,0.8,2.5,2.1c0,0,0,0.1,0,0.1l0,0v20.9h9.7V26.6l0,0c0.4-1.3,1.9-2.1,3.2-1.6 c0.8,0.2,1.4,0.9,1.6,1.6v20.9h9.8V26.6C51.6,20,46.1,14.9,39.6,15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71.1,84.8c8.9,0,16.2-7.3,16.2-16.2s-7.3-16.2-16.2-16.2S55,59.7,55,68.6c0,0,0,0,0,0.1 C55,77.6,62.2,84.8,71.1,84.8C71.1,84.8,71.1,84.8,71.1,84.8z M71.1,61.6c3.9,0,7,3.2,7,7.1s-3.2,7-7.1,7c-3.8,0-7-3.1-7-7 c0-3.9,3.1-7,6.9-7.1C71.1,61.6,71.1,61.6,71.1,61.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.6,52.5c-2.6,0-5.2,0.8-7.3,2.3c-2.2-1.5-4.7-2.3-7.3-2.3c-6.5-0.2-12,4.9-12.3,11.4v20.9h9.8V63.9 c0.1-1.3,1.1-2.3,2.4-2.2c1.3-0.1,2.4,0.8,2.5,2.1c0,0,0,0.1,0,0.1l0,0v20.9h9.7V63.9l0,0c0.4-1.3,1.9-2.1,3.2-1.6 c0.8,0.2,1.4,0.9,1.6,1.6v20.9h9.8V63.9C51.6,57.3,46.1,52.2,39.6,52.5z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMomoPay);
export default __webpack_public_path__ + "static/media/icon_momoPay.2dc7a6b67ca564ace340556fc32e6f27.svg";
export { ForwardRef as ReactComponent };